// extracted by mini-css-extract-plugin
module.exports = {"faq-background":"FAQ_faq-background__2D9a-","wrap":"FAQ_wrap__Fm4UZ","faq":"FAQ_faq__1Z4nz","title":"FAQ_title__1RRro","subtitle":"FAQ_subtitle__1M48M","text":"FAQ_text__3JJlT"};